import { defineStore } from 'pinia';
import {
  randomUUID
} from '../plugins/utils';
import { clear } from 'console';
interface express {
  shop_id: string,
  carry_id: string
}
interface IdCard {
  id_number: string,
  id_name: string,
  id_type: string,
  is_update: boolean,
  has_identity: boolean
}
interface PreviewOrder {
  address: null,
  builing: null,
  shippingMethod: null,
  paymethod: null,
  order: null,
  prepay_id: null,
  promo_code: Array<string>,
  shippingMethods: Array<express>,
  currency: null,
  IdCard: IdCard,
  preview_id: null,
  previewKey: null,
  isShippingUpdate: boolean,
  hasInsurance: boolean,
  hasInsuranceUpdate: boolean,
  paymethodCurreny: null,
  services: null,
  servicesUpdate: boolean,
  billingAndShipping: boolean,
  isAutoPromoCodePush: boolean,
  shippingPageNo: number,
  billingPageNo: number,
  orderNote: string,
  email: string
}
export const usePreviewOrderStore = defineStore('previewOrder', {
  state: (): PreviewOrder => ({
    address: null,
    builing: null,
    shippingMethod: null,
    paymethod: null,
    order: null,
    prepay_id: null,
    promo_code: [],
    shippingMethods: [],
    currency: null,
    IdCard: {
      id_name: '',
      id_number: '',
      id_type: '',
      is_update: false,
      has_identity: false
    },
    preview_id: null,
    previewKey: null,
    isShippingUpdate: false,
    hasInsurance: false,
    hasInsuranceUpdate: false,
    paymethodCurreny: null,
    services: null,
    servicesUpdate: false,
    billingAndShipping: true,
    isAutoPromoCodePush: false,
    shippingPageNo: 1,
    billingPageNo: 1,
    orderNote: "",
    email: ""
  }),
  actions: {
    setAddress(address: any) {
      this.address = address;
    },
    clearAddress() {
      this.address = null;
    },
    setBuiling(builing: any) {
      this.builing = builing;
    },
    clearBuiling() {
      this.builing = null;
    },
    copyAddress() {
      this.builing = this.address;
      this.billingPageNo = this.shippingPageNo;
    },
    setShippingMethod(Method: any) {
      const index = this.shippingMethods.findIndex(item => {
        return String(Method.shop_id) === String(item.shop_id);
      });
      Method.shop_id = String(Method.shop_id);
      if (index === -1) {
        this.shippingMethods.push(Method);
        this.isShippingUpdate = true;
      } else {
        this.isShippingUpdate = true;
        this.shippingMethods[index].carry_id = Method.carry_id;
      }
    },
    clearShippingUpdate() {
      this.isShippingUpdate = false;
    },
    setPaymethod(paymethod: any) {
      this.paymethod = paymethod;
    },
    setOrder(order: any) {
      this.order = order;
    },
    setPrepay_id(prepay_id: any) {
      this.prepay_id = prepay_id;
    },
    setPreview_id(preview_id: any) {
      this.preview_id = preview_id;
    },
    setPromo_code(code: string) {
      this.promo_code.push(code);
    },
    setPromo_codes(codes: Array<string>) {
      if (!this.promo_code) {
        this.promo_code = [];
      }
      this.promo_code = this.promo_code.concat(codes);

    },
    delCode(code: string) {
      if (this.promo_code) {
        const index = this.promo_code.indexOf(code);
        if (index !== -1) {
          this.promo_code.splice(index, 1);
        }
      }
    },
    clearCode() {
      this.promo_code = [];
    },
    del(code: string) {
      const index: number = this.promo_code.indexOf(code);
      if (index !== -1) {
        this.promo_code.slipce(index, 1);
      }
    },
    clearpreviewId() {
      this.preview_id = null;
    },
    clearPrepayId() {
      this.prepay_id = null;
    },
    initPreviewKey() {
      if (this.previewKey === null) {
        this.previewKey = randomUUID();
      }
    },
    // 清除PreviewKey
    clearPreviewKey() {
      this.previewKey = null;
    },
    setCurrency(currency: string) {
      this.currency = currency;
    },
    setIdNumber(id: string) {
      this.IdCard.id_number = id;
      this.IdCard.is_update = true;
    },
    setIdName(name: string) {
      this.IdCard.id_name = name;
      this.IdCard.is_update = true;
    },
    setIsUpdate(isUpdate: boolean) {
      this.IdCard.is_update = isUpdate;
    },
    setIdType(type: string) {
      this.IdCard.id_type = type;
    },
    async setHasIdentity(hasIdentity: boolean) {
      this.IdCard.has_identity = hasIdentity;
    },
    sethasInsurance(hasInsurance: boolean) {
      this.hasInsurance = hasInsurance;
      this.hasInsuranceUpdate = true;
    },
    sethasInsuranceUpdate(hasInsuranceUpdate: boolean) {
      this.hasInsuranceUpdate = hasInsuranceUpdate;
    },
    setPaymethodCurreny(paymethodCurreny: string) {
      this.paymethodCurreny = paymethodCurreny;
    },
    setServices(goodId: string, checkList: any) {
      if (!this.services) {
        this.services = {};
      }
      this.services[goodId] = checkList;
      this.servicesUpdate = true;
    },
    setServicesUpdate(hasServicesUpdate: boolean) {
      this.servicesUpdate = hasServicesUpdate;
    },
    setshippingPageNo(pageNo: number) {
      this.shippingPageNo = pageNo;
    },
    setbillingPageNo(pageNo: number) {
      this.billingPageNo = pageNo;
    },
    setOrderNote(note: string) {
      this.orderNote = note;
    },
    clearIdCard() {
      this.IdCard = {
        id_name: '',
        id_number: '',
        id_type: '',
        is_update: false,
        has_identity: false
      };
    },
    reset() {
      this.address = null;
      this.builing = null;
      this.paymethod = null;
      this.order = null;
      this.promo_code = [];
      this.shippingMethod = null;
      this.shippingMethods = [];
      this.currency = null;
      this.previewKey = null;
      this.IdCard = {
        id_name: '',
        id_number: '',
        id_type: '',
        is_update: false,
        has_identity: false
      };
      this.hasInsurance = false;
      this.hasInsuranceUpdate = false;
      this.paymethodCurreny = null;
      this.services = null;
      this.servicesUpdate = false;
      this.isAutoPromoCodePush = false;
      this.billingPageNo = 1;
      this.shippingPageNo = 1;
      this.orderNote = "";
      this.email = "";
    },
    ClearPreviewOrderInfo() {
      this.builing = null;
      this.promo_code = [];
      this.order = null;
      this.currency = null;
      this.preview_id = null;
      this.prepay_id = null;
      this.previewKey = null;
      this.isShippingUpdate = false;
      this.shippingMethods = [];
      this.hasInsurance = false;
      this.hasInsuranceUpdate = false;
      this.IdCard = {
        id_name: '',
        id_number: '',
        id_type: '',
        is_update: false,
        has_identity: false
      };
      this.paymethodCurreny = null;
      this.services = null;
      this.servicesUpdate = false;
      this.isAutoPromoCodePush = false;
      this.billingPageNo = 1;
      this.orderNote = "";
      this.email = "";
    },
    orderRest() {
      this.shippingMethods = [];
      this.promo_code = [];
    },
    clearShippingMethods() {
      this.shippingMethods = [];
    },
    changeBillingAndShipping(status: boolean) {
      this.billingAndShipping = status;
    },
    setisAutoPromoCodePush(status: boolean) {
      this.isAutoPromoCodePush = status;
    },
    setOrderEmail(email: string) {
      this.email = email;
    }
  },
  persist: {
    enabled: true,
    strategies: [
      // { storage: sessionStorage, paths: ['firstName', 'lastName'] },
      { key: 'PreviewOrder' }
    ]
  }
});
